import { reinitializeAuth } from '@leagueplatform/auth';
import { queryClient } from '../components/react-query-provider-wrapper';

/**
 * Reset the League SDK, which triggers a re-initialization of the auth service
 * and all other services that depend on it.
 */
export const reset = async () => {
  await reinitializeAuth();

  await queryClient.resetQueries();
};
